import { gql } from "lib/apolloClient";
import { processJournalFragment } from "./Fragments";

export const createProcessJournalMutation = gql`
  mutation createProcessJournal($input: PostCompleteInput!) {
    documentation {
      createPost(input: $input) {
        ...processJournalItem
      }
    }
  }
  ${processJournalFragment.basicDetails}
`;

export const updateProcessJournalMutation = gql`
  mutation updateProcessJournal($input: PostCompleteUpdateInput!) {
    documentation {
      updatePost(input: $input) {
        ...processJournalItem
      }
    }
  }
  ${processJournalFragment.basicDetails}
`;

export const deleteProcessJournalMutation = gql`
  mutation deleteProcessJournal($id: ID!) {
    documentation {
      deletePost(id: $id) {
        isSuccess
      }
    }
  }
`;
